const initialState = {
    searchResult : {
        projects:[],
        applications:[],
        environments:[]
    }
}

export default initialState
